import { useTextes } from '@common/config';
import { Z_TEXT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

const NDA_REGEX = /^[A-Za-z\d]{11}$/;

export const Z_NDA =
  Z_TEXT(t['DETAIL_OFA_INFO_MODIF_MSG4'])
    .regex(NDA_REGEX, { error: t['DETAIL_OFA_INFO_MODIF_MSG4'] });


export const NDA_PLACEHOLDER = '12345678911';